import script from "./footList.vue?vue&type=script&setup=true&lang=js"
export * from "./footList.vue?vue&type=script&setup=true&lang=js"

import "./footList.vue?vue&type=style&index=0&id=4dd0b2c5&scoped=true&lang=less"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4dd0b2c5"]])

export default __exports__